/* global readpage, ReadSpeaker */
define(['components/utilities/utilities', 'components/pubsub/pubsub', 'libs/script'], function (utils, pubsub, $script) {
	'use strict';

	/**
	 * Readspeaker integration
	 * A plugin that integrates with readspeaker.
	 * @exports readspeaker
	 */
	var readspeaker = {

		/** Placeholder to contain the readspeaker-link DOM-node. */
		readspeakerLink: null,

		/** DOM-node for the readspeaker-player div. */
		readspeakerPlayer: document.getElementById('readspeaker-player'),

		/** Boolean to indicate if the readspeaker has been triggered (before the readspeaker-library has been loaded). */
		readspeakerTriggered: false,

		/** Delay before re-trigger the readspeaker link if the library wasn't loaded the first time. */
		readspeakerTriggerDelay: 500,

		/** Boolean to indicate if the readspeaker close-link click event has been initiated. */
		closeEventInitiated: false,

		/** Boolean to indicate if the readspeaker was programmatically closed. */
		programmaticallyClosed: false,


		/**
		 * The initialization function for this module.
		 * @param {Object} el - A DOM node.
		 * @public
		 */
		init: function (el) {
			this.readspeakerLink = el;
			this._initEvents();
			this._loadRadspeakerScript();
		},


		/**
		 * Init click event.
		 * If readspeaker is expanded, we close it, lse (if the readspeaker-library is loaded) we start readspeaker.
		 * If the library isn't loaded, we set readspeakerTriggered which will retry to start readspeaker after the library has loaded.
		 * @private
		 */
		_initEvents: function () {
			var that = this;

			utils.addEventListener(this.readspeakerLink, 'click', function (event) {
				if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

				if (utils.hasClass(that.readspeakerPlayer, 'rsexpanded')) {
					var closeLink = document.querySelector('.rsbtn_closer');
					if (closeLink !== null) {
						that.programmaticallyClosed = true;
						closeLink.click();
					}
				}
				else if (typeof(readpage) !== 'undefined') {
					readpage(that.readspeakerLink.getAttribute('href'), 'readspeaker-player');

					if (that.closeEventInitiated === false) {
						that._initCloseEvent();
					}
				} else {
					that.readspeakerTriggered = true;
				}
			});
		},


		/**
		 * Init click-event of readspeaker close button.
		 * @private
		 */
		_initCloseEvent: function () {
			var that = this,
				readspeakerCloseLink = document.querySelector('.rsbtn_closer');

			if (readspeakerCloseLink !== null) {
				utils.addEventListener(readspeakerCloseLink, 'click', function () {
					if (!that.programmaticallyClosed) {
						pubsub.publish('/toggleLink', that.readspeakerLink);
					}
					that.readspeakerLink.focus();
					that.programmaticallyClosed = false;
				});
				this.closeEventInitiated = true;
			}
		},


		/**
		 * Load the readspeaker library (and if the readspeaker-link already has been click, we trigger it again).
		 * @private
		 */
		_loadRadspeakerScript: function () {
			var that = this,
				rsConf = {
					params: mainConfig.readspeakerUrl
				};

			window.rsConf = rsConf; // We store the params where readspeaker want it.

			$script.get(rsConf.params, function () {
				try {
					ReadSpeaker.init();

					if (that.readspeakerTriggered === true) {
						setTimeout(function () {
							that.readspeakerLink.click();
						}, that.readspeakerTriggerDelay);
					}
				} catch (e) {}
			});
		}
	};


	return readspeaker;
});


//////////////////
// WEBPACK FOOTER
// ./components/readspeaker/readspeaker.js
// module id = 19
// module chunks = 4